import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import store from './store'

//引入全局样式
import "./css/global.css";
// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
// 图片预览组件
import ImagePreview from "@/components/ImagePreview";
Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.component("ImageUpload", ImageUpload);
Vue.component("ImagePreview", ImagePreview);
new Vue({
  router,
  render: (h) => h(App),
  store
}).$mount("#app");
